<template>
    <div class="allergens-status" role="status">
        <div class="allergens-status__wrap">
            <img
                class="allergens-status__mascot"
                src="~@/../public/img/alex_carita_01.svg"
                alt=""
                width="70"
                height="71"
            />
            <div class="allergens-status__card">
                <h2 class="allergens-status__title">{{ title }}</h2>
                <p class="allergens-status__description">{{ description }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AllergensStatusMessage',
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.allergens-status {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 0;
    padding: 16px;
    box-sizing: border-box;
    overflow: visible;
}

.allergens-status__wrap {
    position: relative;
    width: 478px;
    max-width: 100%;
    padding-top: 35px;
    box-sizing: border-box;
    overflow: visible;
}

.allergens-status__mascot {
    position: absolute;
    top: 0;
    right: -35px;
    width: 69.899px;
    height: 71px;
    flex-shrink: 0;
    display: block;
    object-fit: contain;
    pointer-events: none;
    z-index: 2;
}

.allergens-status__card {
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    width: 100%;
    min-height: 124px;
    padding: 16px;
    border-radius: 8px;
    background-color: $color-neutral-400;
}

.allergens-status__title {
    margin: 0;
    color: #171718;
    font-family: $text-bold;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 27.5px;
}

.allergens-status__description {
    margin: 16px 0 0;
    color: #171718;
    font-family: $text;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}

.portrait {
    .allergens-status__wrap {
        width: 100%;
        padding-right: 28px;
    }

    .allergens-status__mascot {
        right: 0;
    }
}
</style>
